import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import MiniSidebar from "../MiniSidebar/MiniSidebar";
import AsideCards from "../AsideCards/AsideCards";

import "./Main.css";
import Searchbar from "../Search/SearchBar/Searchbar";
import { Redirect } from "react-router";
import ShareLearnings from "../ShareYourLearnings";
import ProfileService from "../../services/ProfileService";
import { getTickerV2 } from "../../services/TickerService";
import TickerComponent from "../Ticker/TickerComponent";
import TickerComponent2 from "../Ticker/TickerComponent2";
import AsideCardsNew from "../AsideCards/AsideCardsNew";
import { getFromEncLocalStorage } from "../../helpers/Utils/Utils";
// import TickerComponent from "../Ticker/TickerComponent";
// import { getTicker } from "../../services/TickerService";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    // padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    // maxWidth:'1320px'
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  contentNew: {
    flexGrow: 1,
    //padding: theme.spacing(0),
    paddingTop: theme.spacing(1),
  },
}));

function Main(props) {
  const { active } = props;
  const [open, setOpen] = React.useState(true);
  const [isInterestEmpty, setIsInterestEmpty] = useState(false);
  const [showTicker, setShowTicker] = useState(!active?.toLowerCase()?.includes('master'));
  const [tickerData, setTickerData] = useState([{ id: -1, title: "‎" }]);
  const token = getFromEncLocalStorage("token");
  const classes = useStyles();

  const validateInterestsAndExpertise = async () => {
    const data = await ProfileService.getInterests();
    if (data.userInterestList && data.userInterestList.length) {
      setIsInterestEmpty(true);
    }
  }

  const getTickerData = async () => {
    const data = await getTickerV2();
    if (data && data.message === "Ok") {
      setTickerData(data.data)
    }
  }

  useEffect(() => {
    validateInterestsAndExpertise();
    if (showTicker) getTickerData()
  }, [])

  const handleToggle = () => {
    setOpen(!open);
  };
  if (!token) {
    return <Redirect to="/" />;
  }
  return (
    <div className={props.removeContainer ? "" : classes.root} >
      {/* className={classes.root} */}
      {open ? (
        <Sidebar activeLink={active} renderAgain={true} />
      ) : (
        <MiniSidebar activeLink={active} />
      )}

      <div className={props.removeContainer ? "" : "main-section display-row"} >
        {/* // className="" */}
        <Header toggle={handleToggle} isOpen={open} activeLink={active} interestLength={props.interestLength} isInterestEmpty={isInterestEmpty} />


        <main id={open ? "sidebar" : "minisidebar"} className={classes.contentNew}>
          {/* className={classes.content} */}
          <div className={classes.toolbar} />
          <div className="tick-section">
            {showTicker && tickerData && <TickerComponent2 data={tickerData} />}
          </div>
          <div className={props.removeContainer ? "" : "container display-row justify-space-between"}>

            <div className="display-col">
              {active == "home" || active == "all_stories" ? (
                // || active == "questions_for_me" ||
                // active == "que_by_me" ||
                // active == "que_ans_by_me" ||
                // active == "knowledge_by_me"

                <ShareLearnings />
              ) : null}
              <div> {props.children}</div>
            </div>
            {active == "home" ||
              active == "all_stories" ||
              active == "details" ||
              active == "questions_for_me" ||
              active == "que_by_me" ||
              active == "que_ans_by_me" ||
              active == "knowledge_by_me" ? (
              <div className="display-col aside-card">
                <Searchbar />
                <AsideCardsNew location={`/${active}`} />
              </div>
            ) : null}
          </div>
        </main>
      </div>
    </div>
  );
}

export default Main;

Main.propTypes = {
  children: PropTypes.node.isRequired,
  active: PropTypes.string,
  interestLength: PropTypes.number
};
